<template>
  <div class="row" v-on:mousemove="checkInactivityMoveMouse">
    <!-- <div class="col-md-12" v-if="is_morph == false">
            <h1 class="h3 mb-3 text-gray-800">
                {{
                    $t(
                        "Editar Registro de Situação Violação de Direitos"
                    )
                }}
                {{ $t("ID") }} #{{ item.id }}
            </h1>
        </div>
        <load v-if="loading" /> -->
    <header-servico
      v-if="is_morph == false"
      tipo="Situação de Violação de Direitos"
      :loading="loading"
      :familia="familia.id"
      page="violencia"
    />
    <load
      v-if="loading"
      message="Carregando a Situação de Violação de Direitos da Família"
    />
    <div v-else-if="!loading" class="col-md-12">
      <div class="row" v-if="item">
        <SidebarServico @page="showPage" v-if="is_morph == false" />

        <ModalVerificarPrivado
          :familia-id="familia.id"
          v-if="item.privado == 1 && status_privado == false"
          @liberar="status_privado = true"
        />

        <div
          :class="`${is_morph ? 'col-md-12' : 'col-md-9'}`"
          v-else
          v-on:mousemove="status_privado = !checkInactivity"
        >
          <div class="row" v-if="is_morph == false">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div v-if="page == 'violacaodedireito'">
            <div v-if="historicoStatus == false" class="card mb-0 shadow">
              <div class="card-body">
                <div class="tab-content">
                  <div class="animate__animated animate__fadeIn">
                    <div class="row">
                      <div class="col-md-12" v-if="is_morph">
                        <h4 class="font-weight-bold">
                          {{ $t("Editar Registro de Violação de Direitos") }}
                          {{ $t("ID") }} #{{ item.id }}
                        </h4>
                      </div>
                      <Header :item="item" />

                      <form-select
                        v-model="item.pessoas"
                        :multiple="true"
                        label="Vítima"
                        :itens="pessoas"
                        :required="true"
                      />

                      <form-select
                        v-model="item.violencias"
                        label="Violação de Direitos"
                        :multiple="true"
                        :itens="tipos"
                        :required="true"
                      />

                      <form-toggle
                        v-model="item.acompanhamento_creas"
                        grid="12"
                        label="Acompanhamento"
                      />

                      <div class="col-md-12" v-if="item.acompanhamento_creas == 1">
                        <div class="row">
                          <form-select
                            v-model="item.creas_id"
                            label="Unidade"
                            grid="6"
                            :itens="unidades"
                          />

                          <form-calendar
                            v-model="acomp_data_inicial"
                            grid="3"
                            label="Data inicial"
                          />

                          <form-calendar
                            v-model="acomp_data_final"
                            grid="3"
                            label="Data final"
                          />
                        </div>
                      </div>

                      <form-textarea-editor
                        v-model="item.descricao"
                        grid="12"
                        label="Descrição da situação de Violação de Direitos e suas supostas motivações"
                        :required="true"
                      />

                      <form-select
                        v-if="tecnicos"
                        v-model="item.tecnicos"
                        label="Técnicos participantes"
                        :multiple="true"
                        :itens="listtecnicos"
                        :loading="loadingTecnicos"
                        :disabled="loadingTecnicos"
                      />

                      <form-select
                        @change="verificarStatus"
                        v-model="item.status"
                        label="Status"
                        grid="4"
                        :itens="status"
                        :ajuda="ajuda_status"
                      />

                      <form-file
                        grid="8"
                        @submit="submitFile"
                        multiple
                        btn-text="Iniciar"
                        :progress="progressCompleted"
                      />
                    </div>
                    <div class="row pt-4 px-0 d-flex justify-content-end">
                      <div class="mt-2">
                        <form-toggle
                          grid="12"
                          mt="2"
                          v-model="item.privado"
                          label="Sigilo?"
                        />
                      </div>
                      <div class="col-auto px-2 text-right">
                        <a
                          class="router-link-exact-active active px-3"
                          @click="historicoStatus = true"
                        >
                          <i class="fas fa-history"></i>
                          Histórico de Status
                        </a>
                        <a
                          v-if="is_morph"
                          class="btn btn-default"
                          @click="$emit('voltar')"
                        >
                          <i class="mdi mdi-arrow-left" />
                        </a>
                        <router-link
                          v-else
                          :to="
                            '/dashboard/violacaodedireitos/' +
                            $route.query.familia_id +
                            '?familia_id=' +
                            $route.query.familia_id
                          "
                          class="btn btn-default"
                        >
                          <i class="mdi mdi-arrow-left" />
                        </router-link>
                        <a
                          class="btn btn-primary"
                          @click="$bvModal.show('modal-auditoria')"
                          :title="$t('Auditoria')"
                          v-b-tooltip.hover
                        >
                          <i class="mdi mdi-timeline-clock-outline mdi-16px" />
                        </a>
                        <a
                          v-if="
                          $store.state.user.role_details.name == 'Admin' ||
                          $store.state.user.role_details.name == 'Gestor(a)' ||
                          $store.state.user.id == item.user_id
                          "
                          title="Remanejar"
                          class="btn btn-warning py-2"
                          @click="$bvModal.show('modal-remanejar-servico')"
                        >
                          <i class="fas fa-exchange-alt mdi-18px" />
                          {{ $t("Remanejar") }}
                        </a>
                        <b-button
                          :title="$t('Visualizar e Imprimir')"
                          :to="
                            '/dashboard/violacaodedireitos/show/' +
                            item.id +
                            '?familia_id=' +
                            familia.id
                          "
                          class="py-1"
                          size="sm"
                          type="button"
                          v-b-tooltip.hover
                          variant="primary"
                        >
                          <i class="mdi mdi-printer mdi-18px" />
                        </b-button>

                        <b-button
                          v-if="item.status_nome_sf === 'PERSISTE'"
                          :title="$t('Gerar Notificação')"
                          @click.prevent="$bvModal.show('modalNotificacao')"
                          type="button"
                          v-b-tooltip.hover
                          variant="primary"
                        >
                          Gerar Notificação
                        </b-button>

                        <button
                          class="btn btn-success btn-submit"
                          data-style="zoom-in"
                          type="submit"
                          @click="submit"
                        >
                          <i class="mdi mdi-content-save" />
                          {{ $t("Salvar") }}
                        </button>
                      </div>
                    </div>
                    <div v-if="item.anexos">
                      <anexos :anexos="item.anexos" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0 shadow card-body" v-else>
              <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">
                        Registro de Violência e Violação de Direitos
                      </h4>
                    </div>
                    <Header :item="item" />
                    <HistoricoStatus
                      @voltar="historicoStatus = false"
                      :id="item.id"
                      :familia="item.familia_id"
                      :status="status_item"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Atendimento :violacaodedireito="item" v-if="page == 'atendimento'" />
          <Comentario :violacaodedireito="item" v-if="page == 'comentario'" />
          <Encaminhamento :violacaodedireito="item" v-if="page == 'encaminhamento'" />
          <Oficio :violacaodedireito="item" v-if="page == 'oficio'" />
          <Notificacao :violacaodedireito="item" v-if="page == 'notificacao'" />
        </div>
      </div>
    </div>
    <status-historico
      :model="model"
      modulo="ViolenciaViolacaoDireito"
      titulo_modulo="Violação de Direitos"
      :id="item.id"
      :status-anterior="statusAnterior"
      :status-atual="statusAtual"
      :status="status_item"
      @submit="submit"
    />

    <b-modal hide-footer id="modalNotificacao" centered title="Gerar Notificação">
      <form @submit.prevent="submitNotificacao" ref="addNotificacao">
        <div class="row">
          <form-select
            v-model="notificacao.unidades"
            label="Unidades"
            grid="12"
            :itens="unidades"
            multiple
          />

          <form-calendar
            v-model="notificacao.data"
            grid="12"
            label="Data da ocorrência"
            :max-date="dataNow"
          />

          <form-textarea
            v-model="notificacao.situacao"
            grid="12"
            label="Descrição da situação para notificação"
            :required="true"
          />
        </div>
        <div class="row pt-4 px-0 d-flex justify-content-end">
          <button
            class="btn btn-success btn-submit-notificacao"
            data-style="zoom-in"
            type="submit"
          >
            <i class="fas fa-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </form>
    </b-modal>
    <ModalRemanejarServico
      servico="violacaodedireitos"
      :servico_id="item.id"
      :tecnico_id="item.responsavel.id"
    />
    <ModalAuditoria
      servico="vvd"
      :servico_id="item.id"
    />
  </div>
</template>
<script>
import HistoricoStatus from "./HistoricoStatus";
import Header from "./Header";
import SidebarServico from "./includes/SidebarServico";
import Atendimento from "./includes/abas/Atendimento";
import Comentario from "./includes/abas/Comentario";
import Encaminhamento from "./includes/abas/Encaminhamento";
import Oficio from "./includes/abas/Oficio";
import ModalVerificarPrivado from "./includes/ModalVerificarPrivado";
import Notificacao from "./includes/abas/Notificacao";
import ModalRemanejarServico from "../../../../../resources/js/dashboard/components/widgets/ModalRemanejarServico";
import ModalAuditoria from "../../../../../resources/js/dashboard/components/widgets/ModalAuditoria";

export default {
  props: ["morph", "morphVulnerabilidadeId"],
  components: {
    ModalVerificarPrivado,
    HistoricoStatus,
    Header,
    Atendimento,
    Comentario,
    Encaminhamento,
    Oficio,
    Notificacao,
    SidebarServico,
    ModalRemanejarServico,
    ModalAuditoria
  },
  name: "Edit",
  data() {
    return {
      page: "violacaodedireito",
      loading: true,
      statusAtual: "",
      statusAnterior: "",
      historicoStatus: false,
      item: {
        observacoes: "",
        responsavel: {},
      },
      familia: {
        familiares: [],
      },
      files: [],
      status: {},
      status_item: [],
      unidades: [],
      tipos: [],
      loadUser: true,
      progressCompleted: 0,
      disabled: true,
      subtipoAtual: "",
      inativo: false,
      is_morph: false,
      model: "ViolenciaViolacaoDireito",
      status_privado: false,
      loadingTecnicos: true,
      tecnicos: [],
      acomp_data_inicial: null,
      acomp_data_final: null,
      ajuda_status: `<b>ABERTO:</b> O status aberto é indicado quando o usuário da plataforma registra uma Violação de Direitos, no caso esse status aponta que foi iniciado um registro, e posterior será possível o gerenciamento da Violação de Direitos registrada e a indicação de outros status;<br><br>
            <b>INDÍCIO:</b> O status Indício é indicado quando o usuário da plataforma registra uma Violação de Direitos, contudo a mesma não foi confirmada, há apenas indícios da ocorrência de violação de direitos;<br><br>
            <b>CONFIRMADO:</b> O status Confirmado é indicado quando o usuário da plataforma registra uma Violação de Direitos, e gerencia o status para confirmado, quando verifica-se a ocorrência/confirmação do direito violado;<br><br>
            <b>PERSISTE:</b> O status Persiste é indicado quando o usuário da plataforma  gerencia o registro de uma Violação de Direitos, e indica a persistência da situação de violação junto ao grupo familiar e seus membros. ( a indicação desse status gera notificação para o Sistema de Garantia de Direitos, além de histórico das notificações);<br><br>
            <b>EM ACOMPANHAMENTO:</b> O status Em Acompanhamento é registrado sempre que o usuário da Plataforma gerencia o status e sinaliza o acompanhamento da Violação de Direito;<br><br>
            <b>NÃO PROCEDE:</b> O status Não Procede é indicado quando o usuário da plataforma registra uma Violação de Direitos, contudo após as intervenções pertinentes, verifica-se não procedente a ocorrência da violação de direitos ou uma denúncia falsa, gerando o gerenciamento do status;<br><br>
            <b>ENCAMINHADO:</b> O status Encaminhado é indicado sempre que o usuário da Plataforma, após gerenciar o registro da Violação de Direitos, verifica a necessidade de encaminhamento para andamento e articulação da situação identificada, para serviços, programas e projetos da rede intersetorial;<br><br>
            <b>FINALIZADO:</b> O Status Finalizado é indicado sempre que o usuário da Plataforma,após gerenciar o registro de Violação de Direito, atualiza o status para finalizado. Os motivos podem ser: superação da problemática; retorno para cidade de origem (recambio), não adesão ao serviço; mudança de cidade; óbito, encaminhamento para outros serviços, atendimento da situação concluída.<br><br>
            <b>INATIVO:</b>O status inativo é atribuído a um registro quando não há mais necessidade de mantê-lo por várias razões. Normalmente, isso acontece devido à duplicação de informações ou à ausência de dados relevantes. Quando um registro é marcado como inativo, isso indica que ele não está mais em uso ativo e não será mais atualizado ou mantido.`,
      notificacao: {
        data: moment().format("YYYY-MM-DD"),
      },
      notificacoes: [],
      dataNow: moment().format("YYYY-MM-DD"),
    };
  },
  mounted() {
    this.morph ? (this.is_morph = true) : (this.is_morph = false);
    this.getTecnicos();
    this.getStatus();
    this.getUnidades();
    this.getTipos();
    this.getFamilia();
    this.getItem();
    this.getStatusFinais();
    this.$bvModal.show("verificar-atendimento-privado");
  },
  computed: {
    checkInactivity() {
      if (this.$root.isIdle == true) {
        this.status_privado = false;
        this.$bvModal.show("verificar-atendimento-privado");
      }
      return this.$root.isIdle;
    },
    pessoas() {
      let pessoas = this.familia.familiares;
      pessoas = pessoas.filter((elem) => {
        return elem.estado_cadastral_cadunico <= 3;
      });
      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: elem.nome_completo + " <b>" + elem.idade + " ano(s)</b>",
      }));
      return map;
    },
    listtecnicos() {
      const pessoas = this.tecnicos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + (elem.profissao ?? 'Não informado') + " - " + elem.nome_unidade,
      }));
      return map;
    },
  },
  methods: {
    showPage(page) {
      this.page = page;
    },
    getItem() {
      this.loading = true;
      var id = this.is_morph ? this.morphVulnerabilidadeId : this.$route.params.id;
      axios
        .get(`api/dashboard/violacaodedireitos/${id}`)
        .then((response) => {
          this.item = response.data.data;
          this.acomp_data_inicial = this.item.acomp_data_inicial;
          this.acomp_data_final = this.item.acomp_data_final;
          this.statusAnterior = this.item.status;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
    submitFile(files) {
      this.files = files;
    },
    getUnidades() {
      axios.get(`api/dashboard/violacaodedireitos/unidades`).then((response) => {
        this.unidades = response.data;
      });
    },
    getTipos() {
      axios.get(`api/dashboard/violacaodedireitos/tipos`).then((response) => {
        this.tipos = response.data;
      });
    },
    getStatus() {
      axios.get(`api/dashboard/status/violacaodedireitos`).then((response) => {
        this.status = response.data;
      });
    },
    verificarStatus(status) {
      this.statusAtual = status;

      if (this.statusAtual != this.statusAnterior) {
        const result = this.status_item.filter((item) => item.id == status);
        if (result[0].final == 1) {
          //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
          this.$bvModal.show("status-historico-" + this.model);
        }
      }
    },
    getStatusFinais() {
      axios
        .post(`api/dashboard/get/status/finais`, {
          model: "ViolenciaViolacaoDireito",
          module: "ViolenciaViolacaoDireito",
        })
        .then((response) => {
          this.status_item = response.data;
        });
    },
    submit() {
      let formData = new FormData();

      this.item.familia_id = this.familia.id;
      this.item.acomp_data_inicial = this.acomp_data_inicial;
      this.item.acomp_data_final = this.acomp_data_final;

      // if (this.acomp_data_inicial) {
      //   this.item.acomp_data_inicial = moment(
      //     this.acomp_data_inicial,
      //     "YYYY-MM-DD"
      //   ).format("DD/MM/YYYY");
      // }
      // if (this.acomp_data_final) {
      //   this.item.acomp_data_final = moment(
      //     this.acomp_data_final,
      //     "YYYY-MM-DD"
      //   ).format("DD/MM/YYYY");
      // }

      if (this.files.length > 0 && this.files.length != undefined) {
        for (const i of Object.keys(this.files)) {
          formData.append("files[]", this.files[i]);
        }
      } else {
        formData.append("files", this.files);
      }

      for (var key in this.item) {
        formData.append(key, this.item[key]);
      }

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      axios
        .post(`api/dashboard/update/violacaodedireitos`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          ladda.stop();
          if (laddaNotificacao) {
            laddaNotificacao.stop();
          }
          this.item = response.data.data;
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        })
        .finally(() => {
          this.getItem();
          this.progressCompleted = 0;
          this.files = [];
        });
    },
    getFamilia() {
      axios
        .get("api/dashboard/familias/" + this.$route.query.familia_id)
        .then((response) => {
          this.familia = response.data.data;
          this.$route.query.familia_id = this.familia.id;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
    checkInactivityMoveMouse() {
      if (this.item.privado == 1) {
        if (this.$root.isIdle == true) {
          this.status_privado = false;
          this.$bvModal.show("verificar-atendimento-privado");
        }
        return this.$root.isIdle;
      } else {
        return false;
      }
    },
    getTecnicos() {
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`)
        .then((response) => {
          this.tecnicos = response.data;
        })
        .finally(() => {
          this.loadingTecnicos = false;
        });
    },
    submitNotificacao() {
      let ladda = Ladda.create(document.querySelector(".btn-submit-notificacao"));
      ladda.start();
      this.notificacao.violencia_violacao_direito_id = this.$route.params.id;
      axios
        .post(`api/dashboard/vvd/cadastrar/notificacao`, this.notificacao)
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });

          this.$bvModal.hide("modalNotificacao");
        })
        .finally(() => {
          this.getItem();
        });
    },
  },
};
</script>
<style>
.router-link-exact-active {
  cursor: pointer;
}
</style>
